<template>
	<div>
		<el-carousel height="400px">
			<el-carousel-item v-for="(item, index) in sliders" :key="index">
				<div :style="{backgroundImage: 'url(' + item.img + ')'}" class="slider_img"></div>
			</el-carousel-item>
		</el-carousel>
		<div style="background-color: #fff;">
			<div class="member">
				<h2 class="member-t">公司介绍</h2>
				<p class="member-p">寄存寄售行业的数字化首选平台</p>
				<div class="member-img" :style="{backgroundImage: 'url(' + require('../../static/aboutUs/bg.png') + ')'}">
					<p class="introduce">安徽省合肥流转时光旧物寄卖有限公司，由安徽趣玩集团战略投资，专注于为寄存寄售行业提供数字化 SaaS 解决方案。公司以“流转时光”平台为核心，整合订单管理、仓储管理、客户风控、财务报表、合同管理等全流程数字化工具，帮助寄售行实现高效运营与风险可控</p>
					<div class="introduce-list">
						<div class="item">
							<span class="item-t">2017年</span>
							<div class="item-desc">创立时间</div>
						</div>
						<div class="item">
							<span class="item-t">30000+</span>
							<div class="item-desc">服务客户</div>
						</div>
						<div class="item">
							<span class="item-t">10000000</span>
							<div class="item-desc">年营业额</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="honor">
			<h2 class="honor-t">企业荣誉</h2>
			<p class="honor-p">公司多次荣获行业权威奖项，实力有目共睹</p>
			<div class="honor-list">
				<img src="../../static/aboutUs/honor1.png" alt="" />
				<img src="../../static/aboutUs/honor2.png" alt="" />
			</div>
		</div>
		<div class="history" :style="{backgroundImage: 'url(' + require('../../static/aboutUs/development.png') + ')'}">
			<div class="development">
				<h2 class="development-t">发展历程</h2>
				<p class="development-p">一路同行 · 见证成长</p>
			</div>
		</div>
		<div class="honor">
			<h2 class="honor-t">业务发展</h2>
			<p class="honor-p">扎根服务，扩展边界</p>
			<div class="honor-list">
				<img class="business-img" src="../../static/aboutUs/business1.png" alt="" />
				<img class="business-img" src="../../static/aboutUs/business2.png" alt="" />
			</div>
		</div>
	</div>
</template>
<script>
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	export default {
		name: 'Index',
		data() {
			return {
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
			}
		},
		methods: {},
		mounted() {
			this.sliders = [{
					img: require("../../static/aboutUs/banner.png")
				}],
				// 首次加載時，初始化高度
			this.screeWith = window.innerWidth
			this.bannerHeight = 400 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 400 / 1920 * this.screeWith
			}
		},
	}
</script>

<style scoped>
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #ff717b !important;
	}

	.border_parent {
		width: 90%;
		margin: auto;
	}

	.banner-item {
		position: relative;
	}

	.left-img-btns {
		margin-top: 20px;
	}

	.btn {
		display: inline-block;
		width: 200px;
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		text-align: center;
		font-weight: 500;
		font-size: 20px;
		cursor: pointer;
	}

	.btn1 {
		color: #FE3D3A;
		background: #FFFFFF;
		margin-right: 20px;
	}

	.btn2 {
		color: #FFFFFF;
		border: 1px solid #FFFFFF;
	}

	.slider_img {
		height: 400px;
		background-size: auto 100%;
		background-repeat: no-repeat;
		background-position: center center;
	}

	.member {
		width: 1200px;
		margin: 0 auto;
		padding-top: 70px;
		padding-bottom: 70px;
	}

	.member-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}

	.member-p {
		font-weight: 600;
		font-size: 12px;
		color: #999999;
		margin-bottom: 50px;
		text-align: center;
		margin-top: 15px;
	}
	.member-img {
		width: 1200px;
		margin: 0 auto;
		height: 460px;
		background-size: auto 100%;
		background-repeat: no-repeat;
		background-position: center center;
	}
	.introduce {
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		text-align: center;
		padding: 86px 70px 100px;
	}
	.introduce-list {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.introduce-list .item {
		width: 33.33%;
		text-align: center;
		font-weight: 600;
		font-size: 14px;
		color: #333333;
	}
	
	.introduce-list .item .item-t {
		font-size: 50px;
		color: #CF2427;
		margin-bottom: 10px;
	}
	.honor {
		width: 1200px;
		margin: 0 auto;
		padding-top: 70px;
		padding-bottom: 70px;
	}
	.honor-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}
	.honor-p {
		font-weight: 600;
		font-size: 12px;
		color: #999999;
		margin-bottom: 50px;
		text-align: center;
		margin-top: 15px;
	}
	.honor-list {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.honor-list img {
		width: 580px;
		height: 470px;
	}
	.history {
		background-color: #fff;
		height: 500px;
		background-size: auto 100%;
		background-repeat: no-repeat;
		background-position: center center;
		margin: 0 auto;
	}
	.development {
		width: 1200px;
		margin: 0 auto;
		padding-top: 70px;
		padding-bottom: 70px;
	}
	.development-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}
	.development-p {
		font-weight: 600;
		font-size: 12px;
		color: #999999;
		margin-bottom: 50px;
		text-align: center;
		margin-top: 15px;
	}
	.honor-list .business-img {
		height: 300px;
	}
</style>


// WEBPACK FOOTER //
// src/view/aboutUs.vue